module.exports = __webpack_public_path__ + "components/flag/static/square/sd-2005db243bfbe5f0386936164e2b53ab.svg";